import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MarkChatAsProcessedMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  processedAt?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type MarkChatAsProcessedMutation = { __typename: 'PharosMutations', llmChatAdmin_Update: { __typename: 'llm_chat_adminPayload', object: { __typename: 'AdminLlmChatType', id: string, processedAt: string | null } | null } | null };


export const MarkChatAsProcessedDocument = gql`
    mutation markChatAsProcessed($id: ID!, $processedAt: DateTime) {
  llmChatAdmin_Update(input: {id: $id, processedAt: $processedAt}) {
    object {
      id
      processedAt
    }
  }
}
    `;
export type MarkChatAsProcessedMutationFn = Apollo.MutationFunction<MarkChatAsProcessedMutation, MarkChatAsProcessedMutationVariables>;

/**
 * __useMarkChatAsProcessedMutation__
 *
 * To run a mutation, you first call `useMarkChatAsProcessedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkChatAsProcessedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markChatAsProcessedMutation, { data, loading, error }] = useMarkChatAsProcessedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      processedAt: // value for 'processedAt'
 *   },
 * });
 */
export function useMarkChatAsProcessedMutation(baseOptions?: Apollo.MutationHookOptions<MarkChatAsProcessedMutation, MarkChatAsProcessedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkChatAsProcessedMutation, MarkChatAsProcessedMutationVariables>(MarkChatAsProcessedDocument, options);
      }
export type MarkChatAsProcessedMutationHookResult = ReturnType<typeof useMarkChatAsProcessedMutation>;
export type MarkChatAsProcessedMutationResult = Apollo.MutationResult<MarkChatAsProcessedMutation>;
export type MarkChatAsProcessedMutationOptions = Apollo.BaseMutationOptions<MarkChatAsProcessedMutation, MarkChatAsProcessedMutationVariables>;